import { useEffect } from "react";

import { FEATUREBASE_APP_ID } from "../../constants";

declare global {
  interface Window {
    Featurebase: ((...args: unknown[]) => void) & { q?: unknown[] };
  }
}

let featurebaseBooted = false;

export function UnauthenticatedFeaturebaseWrapper() {
  useEffect(() => {
    // Initialize Featurebase if it doesn't exist
    if (typeof window.Featurebase !== "function") {
      window.Featurebase = function featurebaseQueue(...args: unknown[]) {
        window.Featurebase.q = window.Featurebase.q ?? [];
        window.Featurebase.q.push(args);
      };
    }

    // Load the SDK script if not already loaded
    if (!document.getElementById("featurebase-sdk")) {
      const script = document.createElement("script");
      script.id = "featurebase-sdk";
      script.src = "https://do.featurebase.app/js/sdk.js";
      script.async = true;
      document.head.appendChild(script);
    }

    // Boot Featurebase messenger with configuration (only once)
    if (!featurebaseBooted) {
      window.Featurebase("boot", {
        appId: FEATUREBASE_APP_ID,
        theme: "light",
        language: "en",
      });
      featurebaseBooted = true;
    }
  }, []);

  return null;
}
